﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';

@Component({ templateUrl: 'grado.component.html' })
export class GradoRootComponent {


    cambio: Boolean = false;
    

    constructor(private restService: RestService) {
    }


    pasar(){
        this.restService.get('/rest-api/root/grado')
        .subscribe(
            data => {
                this.cambio = true;

            });
    }

}
